import {useEffect, useLayoutEffect, useRef, useState} from "react";
import {observer} from "mobx-react";
import {FormattedMessage} from "react-intl";
import {InnerLink} from "../../../styles/components";
import {useStores} from "../../../hooks/useStores";
import * as S from './styles'
import Rocks from "./Rocks";
import RocksDark from "./RocksDark";
import {Link} from "react-router-dom";

import Phone from '../../../assets/images/m_banner_phone.png'
import DarkPhone from '../../../assets/images/m_banner_dark_phone.png'
import InfoImage from '../../../assets/images/m_banner_info.png'

import {ReactComponent as TwitterIcon} from '../../../assets/icons/social/tv2.svg';
import {ReactComponent as TwitterIconDark} from '../../../assets/icons/social/tv2_d.svg';
import {ReactComponent as FacebookIcon} from '../../../assets/icons/social/fb2.svg';
import {ReactComponent as FacebookIconDark} from '../../../assets/icons/social/fb2_d.svg';
import {ReactComponent as InstagramIcon} from '../../../assets/icons/social/inst2.svg';
import {ReactComponent as InstagramIconDark} from '../../../assets/icons/social/inst2_d.svg';
import {ReactComponent as VKIcon} from '../../../assets/icons/social/vk2.svg';
import {ReactComponent as VKIconDark} from '../../../assets/icons/social/vk2_d.svg';
import {ReactComponent as LinkedInIcon} from '../../../assets/icons/social/in2.svg';
import {ReactComponent as LinkedInIconDark} from '../../../assets/icons/social/in2_d.svg';

function useShowTextBlock(delay: number, show: Function) {
    useEffect(() => {
        let timer = setTimeout(() => show(true), delay)
        return () => clearTimeout(timer);
    })
}

export const Banner = observer(() => {
    const {uiStore} = useStores();

    const bannerRef = useRef<HTMLDivElement>(null);
    const [dwlTop, setDwlTop] = useState(0);
    const [dwlFixed, setDwlFixed] = useState(false)

    const [visPhone, showPhone] = useState(false);
    const [visText1, showText1] = useState(false);
    const [visText2, showText2] = useState(false);
    const [visText3, showText3] = useState(false);

    const [showFooter, setShowFooter] = useState(true);

    const [scrolled, scroll] = useState(false);

    useEffect(() => {
        const onScroll = () => {
            const bannerHeight = bannerRef?.current?.getBoundingClientRect().height || 0;
            if (window.scrollY > bannerHeight - (bannerHeight / 10)) {
                setDwlFixed(true)
            } else {
                setDwlFixed(false)
            }

            if (window.scrollY > 50) {
                scroll(true)
            } else {
                scroll(false);
            }
        };
        window.removeEventListener('scroll', onScroll);
        window.addEventListener('scroll', onScroll, { passive: true });
        return () => window.removeEventListener('scroll', onScroll);
    }, []);

    useEffect(() => {
        let timer = setTimeout(() => setShowFooter(false), 2500)
        return () => clearTimeout(timer);
    })

    useLayoutEffect(() => {
        const onResize = () => {
            const bannerHeight = bannerRef?.current?.getBoundingClientRect().height || 0;
            setDwlTop(bannerHeight - (bannerHeight / 4) - 20);
        };
        window.removeEventListener('resize', onResize);
        window.addEventListener('resize', onResize, { passive: true });
        onResize();
        return () => window.removeEventListener('resize', onResize);
    }, []);

    useShowTextBlock(500, (val) => {showPhone(val); showText1(val); showText2(val); showText3(val);})

    const Social = uiStore.isLightTheme
        ?
        <S.SocialBlock>
            <S.SocialLink to={'/'}><TwitterIcon/></S.SocialLink>
            <S.SocialLink to={'/'}><FacebookIcon/></S.SocialLink>
            <S.SocialLink to={'/'}><InstagramIcon/></S.SocialLink>
            <S.SocialLink to={'/'}><VKIcon/></S.SocialLink>
            <S.SocialLink to={'/'}><LinkedInIcon/></S.SocialLink>
        </S.SocialBlock>
        :
        <S.SocialBlock>
            <S.SocialLink to={'/'}><TwitterIconDark/></S.SocialLink>
            <S.SocialLink to={'/'}><FacebookIconDark/></S.SocialLink>
            <S.SocialLink to={'/'}><InstagramIconDark/></S.SocialLink>
            <S.SocialLink to={'/'}><VKIconDark/></S.SocialLink>
            <S.SocialLink to={'/'}><LinkedInIconDark/></S.SocialLink>
        </S.SocialBlock>

    return (
        <S.Container>
            <S.Banner ref={bannerRef}>
                <S.Logo>
                    <S.Phone show={visPhone} src={uiStore.isLightTheme ? Phone : DarkPhone}/>
                    <S.Text1 show={visText1}><FormattedMessage id="bannerText2"/></S.Text1>
                    <S.Text2 show={visText2}><FormattedMessage id="bannerText1"/></S.Text2>
                    <S.Text3 show={visText3}><FormattedMessage id="bannerText3"/></S.Text3>
                </S.Logo>

                <S.Info>
                    <h3><b>Call us on regular phones</b></h3>
                    <p>
                        <img src={InfoImage} alt={''}/>
                        TeleGuard offers its users around the world the opportunity to make inexpensive calls to mobile and landline phones via IP telephony.
                    </p>
                    <InnerLink to={'/'}>DETAILED {'>'}</InnerLink>
                </S.Info>

                <S.DownloadBlock ref={bannerRef} top={dwlTop} fixed={dwlFixed}>
                    <Link to={'/download'}>
                        <S.DwlButton1 hide={scrolled}>
                            {
                                scrolled
                                ?
                                <>
                                    <svg width="38" height="30" viewBox="0 0 38 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path fillRule="evenodd" clipRule="evenodd" d="M13.1484 5.39414C11.6011 6.83832 10.4999 9.05476 10.4999 12.1726C10.4999 13.001 9.82832 13.6726 8.9999 13.6726C7.00392 13.6726 5.5744 14.5476 4.65643 15.8279C3.71022 17.1476 3.27839 18.9516 3.48967 20.7473C3.69954 22.531 4.53075 24.2052 5.98203 25.3312C7.41598 26.4437 9.6119 27.1414 12.788 26.6877C13.6081 26.5705 14.3679 27.1404 14.4851 27.9605C14.6022 28.7806 14.0324 29.5404 13.2123 29.6575C9.38832 30.2038 6.33418 29.4015 4.14306 27.7015C1.96928 26.0149 0.800411 23.5642 0.510225 21.0979C0.221452 18.6436 0.789574 16.0726 2.21834 14.0798C3.43361 12.3848 5.2496 11.147 7.56192 10.7829C7.8551 7.56108 9.1689 5.0047 11.1015 3.20098C13.2821 1.16572 16.1599 0.172555 18.9999 0.172562C21.8399 0.172568 24.7178 1.16574 26.8984 3.20101C28.8309 5.00473 30.1447 7.5611 30.4379 10.7829C32.7502 11.147 34.5662 12.3848 35.7815 14.0798C37.2103 16.0726 37.7784 18.6436 37.4897 21.0979C37.1995 23.5641 36.0307 26.0149 33.8569 27.7015C31.6658 29.4015 28.6117 30.2038 24.7878 29.6575C23.9677 29.5404 23.3978 28.7806 23.515 27.9605C23.6321 27.1404 24.3919 26.5705 25.212 26.6877C28.3881 27.1414 30.584 26.4437 32.0179 25.3312C33.4692 24.2052 34.3004 22.531 34.5102 20.7473C34.7215 18.9516 34.2896 17.1476 33.3434 15.8279C32.4254 14.5476 30.9959 13.6726 28.9999 13.6726C28.1715 13.6726 27.4999 13.001 27.4999 12.1726C27.4999 9.05478 26.3987 6.83835 24.8514 5.39416C23.2821 3.92941 21.1599 3.17257 18.9999 3.17256C16.8399 3.17256 14.7178 3.92939 13.1484 5.39414Z" fill="white"/>
                                        <path fillRule="evenodd" clipRule="evenodd" d="M11.6906 18.9614C12.2842 18.3835 13.2338 18.3962 13.8118 18.9897L17.5154 22.7934V11.1726C17.5154 10.3442 18.187 9.67259 19.0154 9.67259C19.8439 9.67259 20.5154 10.3442 20.5154 11.1726V22.7934L24.2191 18.9897C24.797 18.3962 25.7467 18.3835 26.3402 18.9614C26.9338 19.5394 26.9464 20.489 26.3685 21.0826L20.0901 27.5305C19.8078 27.8205 19.4202 27.9841 19.0154 27.9841C18.6107 27.9841 18.2231 27.8205 17.9407 27.5305L11.6624 21.0826C11.0844 20.489 11.0971 19.5394 11.6906 18.9614Z" fill="white"/>
                                    </svg>
                                    <span><FormattedMessage id="bannerDownloadButton2"/></span>
                                </>
                                :
                                <FormattedMessage id="bannerDownloadButton"/>
                            }
                        </S.DwlButton1>
                    </Link>
                    {/*<Link to={'/download'}>
                        <S.DwlButton2 show={scrolled}>
                            <svg width="38" height="30" viewBox="0 0 38 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path fillRule="evenodd" clipRule="evenodd" d="M13.1484 5.39414C11.6011 6.83832 10.4999 9.05476 10.4999 12.1726C10.4999 13.001 9.82832 13.6726 8.9999 13.6726C7.00392 13.6726 5.5744 14.5476 4.65643 15.8279C3.71022 17.1476 3.27839 18.9516 3.48967 20.7473C3.69954 22.531 4.53075 24.2052 5.98203 25.3312C7.41598 26.4437 9.6119 27.1414 12.788 26.6877C13.6081 26.5705 14.3679 27.1404 14.4851 27.9605C14.6022 28.7806 14.0324 29.5404 13.2123 29.6575C9.38832 30.2038 6.33418 29.4015 4.14306 27.7015C1.96928 26.0149 0.800411 23.5642 0.510225 21.0979C0.221452 18.6436 0.789574 16.0726 2.21834 14.0798C3.43361 12.3848 5.2496 11.147 7.56192 10.7829C7.8551 7.56108 9.1689 5.0047 11.1015 3.20098C13.2821 1.16572 16.1599 0.172555 18.9999 0.172562C21.8399 0.172568 24.7178 1.16574 26.8984 3.20101C28.8309 5.00473 30.1447 7.5611 30.4379 10.7829C32.7502 11.147 34.5662 12.3848 35.7815 14.0798C37.2103 16.0726 37.7784 18.6436 37.4897 21.0979C37.1995 23.5641 36.0307 26.0149 33.8569 27.7015C31.6658 29.4015 28.6117 30.2038 24.7878 29.6575C23.9677 29.5404 23.3978 28.7806 23.515 27.9605C23.6321 27.1404 24.3919 26.5705 25.212 26.6877C28.3881 27.1414 30.584 26.4437 32.0179 25.3312C33.4692 24.2052 34.3004 22.531 34.5102 20.7473C34.7215 18.9516 34.2896 17.1476 33.3434 15.8279C32.4254 14.5476 30.9959 13.6726 28.9999 13.6726C28.1715 13.6726 27.4999 13.001 27.4999 12.1726C27.4999 9.05478 26.3987 6.83835 24.8514 5.39416C23.2821 3.92941 21.1599 3.17257 18.9999 3.17256C16.8399 3.17256 14.7178 3.92939 13.1484 5.39414Z" fill="white"/>
                                <path fillRule="evenodd" clipRule="evenodd" d="M11.6906 18.9614C12.2842 18.3835 13.2338 18.3962 13.8118 18.9897L17.5154 22.7934V11.1726C17.5154 10.3442 18.187 9.67259 19.0154 9.67259C19.8439 9.67259 20.5154 10.3442 20.5154 11.1726V22.7934L24.2191 18.9897C24.797 18.3962 25.7467 18.3835 26.3402 18.9614C26.9338 19.5394 26.9464 20.489 26.3685 21.0826L20.0901 27.5305C19.8078 27.8205 19.4202 27.9841 19.0154 27.9841C18.6107 27.9841 18.2231 27.8205 17.9407 27.5305L11.6624 21.0826C11.0844 20.489 11.0971 19.5394 11.6906 18.9614Z" fill="white"/>
                            </svg>
                            <span><FormattedMessage id="bannerDownloadButton2"/></span>
                        </S.DwlButton2>
                    </Link>*/}
                </S.DownloadBlock>

                {uiStore.isLightTheme ? <Rocks showFooter={showFooter}/> : <RocksDark showFooter={showFooter}/>}

                {Social}
            </S.Banner>
        </S.Container>
    )
})



